import React from 'react';
import './loader.css';

/* [CF 2026-08-17] ONE loading indicator for the whole site.
 *
 * There used to be two, and which one you saw depended on which kind of wait you
 * hit. Anything routed through the Redux loader showed GlobalLoader — the
 * rotating amber balls, full screen. Every page-level wait (a category listing
 * fetching its rows) showed a Bootstrap spinner instead, a thin rotating arc.
 * Same site, same moment in the journey, two different loaders — plus Car
 * Dealers had a card shimmer and Taxi / Air Conditioning had nothing at all.
 *
 * The client picked the amber balls, so this renders exactly that, inline
 * wherever a screen is waiting for its own data. It deliberately carries no
 * padding of its own — the call sites already provide their spacing, and adding
 * more here would double it.
 */
export default function PageLoader() {
  return (
    <div className="page-loader">
      <div className="ball-loader">
        {[...Array(6)].map((_, i) => (
          <div key={i} className={`ball ball${i + 1}`} />
        ))}
      </div>
    </div>
  );
}
